<template>
<div class="evaluation_section_selector animate_class" @click="gotoSection">
<div class="grid p-0 m-0">
<div class="col-10 p-0 m-0">
<p class="mt-0 mb-0">{{labeltext}}
<span class="text-green-500 ml-4 font-bold" v-if="show_points"><template v-if="sectionpoints!==''">{{sectionpoints}} {{ $store.state.languages.lang_phrases.puan}}</template></span>
</p>
</div>
<div class="col-2 p-0 m-0 flex align-items-center justify-content-center flex-column">

<p class=" mx-0 my-0" style="line-height: 26px;">  
<span class="text-primary">{{completion.total}}</span> / <span class="text-purple-500">{{completion.completed}}</span>

</p>
<div class="w-full">
<div class="audit_progress">
  <div class="audit_progress_bar" :style="'width:'+completion.percentage+'%;background-color:'+bar_color">
    <p class="audit_progress_percent">{{completion.percentage}}%</p>
  </div>
</div>


</div>
<!--

 <template v-if="status=='in_progress'">
    <span class="material-icons-outlined md-30 mr-2 text-cyan-500"
    v-tooltip.left="{ value: $store.state.languages.lang_phrases.beklemede, disabled: false,class: 'custom-top-tooltip' }"
    >
    mode_standby
    </span>
  </template>
  <template v-if="status=='completed'">
    <span class="material-icons-outlined md-30 mr-2 text-green-400"
    v-tooltip.left="{ value: $store.state.languages.lang_phrases.tamamlandi, disabled: false,class: 'custom-top-tooltip' }"
    >
    check_circle
    </span>
  </template>
  <template v-if="status=='untouched'">
  <span class="material-icons-outlined md-30 mr-2 text-yellow-400"
  v-tooltip.left="{ value: $store.state.languages.lang_phrases.baslanmadi, disabled: false,class: 'custom-top-tooltip' }"

  >
    not_started
    </span>
</template>

-->

</div>
</div>
</div>
</template>
<script>
export default {

  name: 'AuditSectionSelector',
  props:["data"],

  data () {
    return {
      completion:{
        total:0,
        completed:0,
        percentage:0,
      }
    }
  },
  mounted()
  {
    
    let fields = this.getSectionInputfields()

    this.completion.total = fields.length
    for(let item of fields)
    {
      if(item.completion)
      {
        this.completion.completed +=1
      }
    }

    
    let percentage = (100/this.completion.total)*this.completion.completed
    percentage = percentage.toFixed(2)
    
    setTimeout(()=>{
      this.completion.percentage = parseFloat(percentage)
    })
    
   
  },
  computed:{
    bar_color()
    {
      if(this.completion.percentage<50)
      {
        return "#ff4032"
      }
      if(this.completion.percentage<75 && this.completion.percentage>=50)
      {
        return "#00bcd4"
      }
      if(this.completion.percentage>75 && this.completion.percentage<100)
      {
        return "#352f8d"
      }
      if(this.completion.percentage>=100)
      {
        return "#4caf50"
      }
    },
  	labeltext()
  	{
  		return this.getTheTranslation(this.data,"translation")
  	},
    show_points()
    {
      let status = this.$store.state.audit.audit.status
      if(status=="finished" || status=="correction_requested" || status=="under_review")
      {
        return true
      }
      else
      {
        return false
      }
    },
    sectionpoints()
    {
      if(this.data.points)
      {
        return this.data.points.points
      }
      else
      {
        return ""
      }
    },
    status()
    {
    	return "untouched"
      let sectioninputfields = this.$store.state.audit.questionlist.inputfifld.filter((item)=>{return item.inputfieldsection_id == this.data.id})
      let inputfields = sectioninputfields
      let completed = 0
      let uncompleted = 0
      for(let item of inputfields)
      {
        if(item.completion)
        {
          completed++
        }
        else
        {
          uncompleted++
        }
      }
      if(completed===0)
      {
        return "untouched"
      }
      if(uncompleted===0)
      {
        return "completed"
      }
      if(completed>0 && uncompleted>0)
      {
        return "in_progress"
      }
    },
  },
  methods:{
  	gotoSection()
  	{
  		this.$router.push({ name: 'AuditQuestionListSection', params: { section_id:this.data.id } })
  	},
    getSectionInputfields()
    {
      let inputfields = this.$store.state.evaluation.inputfields
      let inputfieldsections = this.$store.state.evaluation.sections
      //let parent_inputfields = inputfields.filter((item)=>{return item.inputfieldsection_id==this.data.id})
      let child_inputfields = this.getChildSectionInputfields(this.data.id,inputfields,inputfieldsections)

      //let final = parent_inputfields.concat(child_inputfields)
      return child_inputfields

    },
    getChildSectionInputfields(parent_id,inputfields,inputfieldsections)
    {

      let child_inputfields = inputfields.filter((item)=>{return item.inputfieldsection_id==parent_id})
      let child_sections = inputfieldsections.filter((item)=>{return item.parent_id == parent_id})
      for(let child_section of child_sections)
      {
        
        let fields = this.getChildSectionInputfields(child_section.id,inputfields,inputfieldsections)
        child_inputfields = child_inputfields.concat(fields)
      }
      return child_inputfields
    },
  }
}
</script>

<style lang="css" scoped>
</style>